import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-3" }, "Afspraken", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, "Klik op een afspraak om de opmerking/uit te voeren werken te laten verschijnen", -1)
const _hoisted_7 = { class: "mt-5" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<li class=\"row\" style=\"background-color:lightgray;border-radius:5px 5px 0px 0px;\"><div class=\"col-2\">Datum</div><div class=\"col-1\">Voorn.</div><div class=\"col-2\">Naam</div><div class=\"col-3\">Email</div><div class=\"col-2\">Telefoon</div><div class=\"col-2\">Nummerplaat</div></li>", 1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "col-2" }
const _hoisted_11 = { class: "col-1" }
const _hoisted_12 = { class: "col-2" }
const _hoisted_13 = { class: "col-3" }
const _hoisted_14 = { class: "col-2" }
const _hoisted_15 = { class: "col-2" }
const _hoisted_16 = {
  key: 0,
  class: "row",
  style: {"background-color":"lightgray"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.Afspraken)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.Afspraken)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Download && _ctx.Download(...args)))
          }, "Download de afspraken in excel"),
          _createElementVNode("ul", _hoisted_7, [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Afspraken, (afspraak) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: afspraak.AFSPRAAK_ID
              }, [
                _createElementVNode("li", {
                  class: "row",
                  onClick: ($event: any) => (_ctx.Ouvrir(afspraak.AFSPRAAK_ID))
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.DateFormat(afspraak.AFSPRAAK_UPDDAT)), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(afspraak.AFSPRAAK_VOORNAAM), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(afspraak.AFSPRAAK_NAAM), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(afspraak.AFSPRAAK_EMAIL), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(afspraak.AFSPRAAK_TELEFOON), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(afspraak.AFSPRAAK_NUMMERPLAAT), 1)
                ], 8, _hoisted_9),
                _createVNode(_Transition, { name: "afspraak" }, {
                  default: _withCtx(() => [
                    (afspraak.AFSPRAAK_ID == _ctx.open)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_16, _toDisplayString(afspraak.AFSPRAAK_OPMERKING), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ], 64))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}